<template>
  <el-select
    style="width: 100%"
    v-model="localValue"
    size="size"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
    :placeholder="placeholder"
    @change="selected"
    filterable
  >
    <el-option
      v-for="evaluation in evaluations"
      v-if="evaluation.name"
      :key="evaluation.id"
      :label="evaluation.name"
      :value="evaluation.id"
    />
  </el-select>
</template>

<script>
export default {
  name: "eval-evaluations-select",
  props: {
    value: '',
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Оценки' },
  },
  data() {
    return {
      localValue: this.value,
      evaluations: [],
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadEvaluations();
    });
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    loadEvaluations() {
      this.$api.evaluation.evaluationSearch()
        .then(({data}) => {
          this.evaluations = data.evaluations;
        });
    },
  },
};
</script>

<style scoped>

</style>
